import React, { useEffect, useState } from "react"
import { Box, Button } from "@material-ui/core"
import { makeStyle } from "./style.js"
import { Header } from "./../../../components/Header/index.js"
import Icon from "../../../utils/icons.js"
import { PAGES,IQ_AIR_MODEL } from "../../../utils/constant.js"
import ProvisionStepper from "../provisionStepper/index.js"
import I18n from "../../../localization/index.js"

const ConfirmSite = (props) => {
  const { handleClick, isDarkMode, siteId, siteInfo, hasAccess, maskedOwnerEmail,iqAirModel} = props
  const classes = makeStyle()
  return (
    <>
      <Header
        title={I18n.t('mobile.AirDeviceProvisioning.confirmSite.title')}
        onClick={() => handleClick(PAGES.AIR_DEVICES_PROVISION)}
      />
      <Box className={classes.confirmSiteContainer}>
        <ProvisionStepper activeStep={0} progressSteps={{step1:0, step2:0, step3:0}} />
        <Box className={classes.confirmSiteWrapper}>
          <Box className={classes.confirmSiteHeading}>
              {I18n.t('mobile.AirDeviceProvisioning.confirmSite.title')}
          </Box>
          <Box className={classes.confirmSiteSubHeading}>
              {iqAirModel === IQ_AIR_MODEL.IQ_AIR_HUB.ID ? I18n.t('mobile.AirDeviceProvisioning.confirmSite.subHeading'):I18n.t('mobile.AirDeviceProvisioning.confirmSite.subHeadingSecondary')}
          </Box>
          <Box className={classes.siteAddressCard}>
              <Box className={classes.siteName}>
                  {siteInfo?.name}
              </Box>
              <Box className={classes.siteAddressDetails}>
                  <div className={classes.addressLine}>{I18n.t('mobile.AirDeviceProvisioning.confirmSite.siteID') + ` : ${siteId}`}</div>
                  {siteInfo?.address.map((address,index)=>( <div className={classes.addressLine} key={index} >{address}</div> ))}
              </Box>
          </Box>
        </Box>
        <Box className={classes.buttonContainer}>
            {/* <Button className={classes.newSiteButton} onClick={()=>handleClick(PAGES.SITE_DETAILS, PAGES.CONFIRM_SITE)}>
              <div className={classes.inSiteButton}>
                  <Icon src={'addIconV2'} />
                  <span>{'Create new site'}</span>
              </div>
            </Button> */}
            <Button className={classes.continueButton} onClick={()=>handleClick(PAGES.AIR_DEVICE_INTEGRATION)}>
            {I18n.t('mobile.common.continue')}
            </Button>
        </Box>
      </Box>
    </>
  )
}

export default ConfirmSite
